import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { resolveLogicalLinkRoute } from "./hrTaskLinks";
import { HrTaskContentRow, HrTaskContentRowType } from "./types";

type Props = {
  rows: HrTaskContentRow<string>[];
  variant?: "body1" | "body2";
};

const HrTaskContentRows = ({ rows, variant = "body1" }: Props) => (
  <Box display="flex" flexDirection="column" gap={variant === "body1" ? 1 : 0}>
    {rows.map((row, index) => {
      const to =
        row.type === HrTaskContentRowType.LINK && row.link
          ? resolveLogicalLinkRoute(row.link.target)
          : undefined;

      return to ? (
        <Typography
          key={index}
          component={Link}
          to={to}
          variant={variant}
          target={row.link?.openInNewTab ? "_blank" : undefined}
          rel={row.link?.openInNewTab ? "noopener noreferrer" : undefined}
          color="primary"
          sx={{
            // Keep row links above the card's stretched navigation link.
            position: "relative",
            zIndex: 1,
            textDecoration: "none",
            "&:hover": { textDecoration: "underline" },
          }}
        >
          {row.text} →
        </Typography>
      ) : (
        <Typography key={index} variant={variant} component="div">
          {row.text}
        </Typography>
      );
    })}
  </Box>
);

export default HrTaskContentRows;
